export const PRICE_UPDATE_REQUESTED = "PRICE_UPDATE_REQUESTED";
export const PRICE_UPDATE_SUCCESS = "PRICE_UPDATE_SUCCESS";
export const PRICE_UPDATE_FAILED = "PRICE_UPDATE_FAILED";